/**
 * Created by laugh on 8/24/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import logo from '../../assets/img/mealtrist-logo.png';
import { Link } from 'react-router-dom';
import * as ReactBootstrap from 'react-bootstrap';
import '../../App.css';

class MealtristHeader extends React.Component {
    constructor(props) {
        super(props);
        console.log(props.testing);
        this.state = {redirecting: false, provider: "cox", leadSource: "500", tfn: "772-452-4565", text: "The TransactionID is "};
    }

    componentWillMount() {
        // if(this.state.provider != "") {
        //     require('../assets/css/' + this.state.provider + '.css');
        // }

    }

    //TODO set referrer url link in containers first child link
    render() {
        return (
            <div>
                <header>
                    <div className="container">
                        <div className="row">
                                <ReactBootstrap.Navbar fluid collapseOnSelect>
                                    <ReactBootstrap.Navbar.Header>
                                        <ReactBootstrap.Navbar.Brand>
                                            <a><img className="img-responsive" height="60" width="60" src={logo} alt="mealtrist-logo" /></a>
                                        </ReactBootstrap.Navbar.Brand>
                                        <ReactBootstrap.Navbar.Toggle />
                                    </ReactBootstrap.Navbar.Header>
                                    <ReactBootstrap.Navbar.Collapse>
                                        <ReactBootstrap.Nav>
                                            <ReactBootstrap.NavItem eventKey={1} href="#">
                                                <Link to="/feed">Mealtrist Feed</Link>
                                            </ReactBootstrap.NavItem>
                                            <ReactBootstrap.NavItem eventKey={2} href="#">
                                                <Link to="/saved" >Saved Recipes</Link>
                                            </ReactBootstrap.NavItem>
                                            <ReactBootstrap.NavItem eventKey={3} href="#">
                                                <Link to="/plan" >Plan</Link>
                                            </ReactBootstrap.NavItem>
                                            <ReactBootstrap.NavItem eventKey={4} href="#">
                                                <Link to="/connections" >Connections</Link>
                                            </ReactBootstrap.NavItem>
                                            <ReactBootstrap.NavItem eventKey={5} href="#">
                                                <Link to="/add-meal" >+ Meal</Link>
                                            </ReactBootstrap.NavItem>
                                            {/*<ReactBootstrap.NavDropdown eventKey={6} title="Dropdown" id="basic-nav-dropdown">*/}
                                                {/*<ReactBootstrap.MenuItem eventKey={6.1}>Action</ReactBootstrap.MenuItem>*/}
                                                {/*<ReactBootstrap.MenuItem eventKey={6.2}>Another action</ReactBootstrap.MenuItem>*/}
                                                {/*<ReactBootstrap.MenuItem eventKey={6.3}>Something else here</ReactBootstrap.MenuItem>*/}
                                                {/*<ReactBootstrap.MenuItem divider />*/}
                                                {/*<ReactBootstrap.MenuItem eventKey={6.4}>Separated link</ReactBootstrap.MenuItem>*/}
                                            {/*</ReactBootstrap.NavDropdown>*/}
                                        </ReactBootstrap.Nav>
                                        <ReactBootstrap.Nav pullRight>
                                            <ReactBootstrap.NavItem eventKey={7} href="#">
                                                <Link to="/profile" >Profile</Link>
                                            </ReactBootstrap.NavItem>
                                            <ReactBootstrap.NavItem eventKey={8} href="#">
                                                <Link to="/" >Logout</Link>
                                            </ReactBootstrap.NavItem>
                                        </ReactBootstrap.Nav>
                                    </ReactBootstrap.Navbar.Collapse>
                                </ReactBootstrap.Navbar>
                        </div>
                    </div>
                </header>
            </div>
        );
    }
}

export default MealtristHeader;


// WEBPACK FOOTER //
// ./src/components/Core/mealtristHeader.js